import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxibookinginracnchi() {



  const cardData =
  {
    keyword: 'Taxi Booking in Ranchi',
    heading: 'Aaryan Travels: Taxi Booking in Ranchi',
    headingDescription: ' Aaryan Travels offers convenient Taxi Booking in Ranchi for local travel, airport transfers, office commute, and outstation trips. Whether you need a quick ride within the city or a long-distance cab to destinations like Jamshedpur, Dhanbad, or Kolkata, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey. With easy booking options, 24/7 availability, professional chauffeurs, and transparent pricing, we make travel in Ranchi stress-free and reliable. From Kanke Road to Lalpur, Hinoo to Morabadi, Aaryan Travels provides doorstep pickup and fast taxi service across Ranchi for individuals, families, and corporate travelers.',

    top: 'Top Places to Visit in Ranchi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Tagore Hill",
    "description": "Tagore Hill is a peaceful hilltop named after Nobel laureate Rabindranath Tagore, who is believed to have spent time here reflecting and writing. The viewpoint offers panoramic scenes of Ranchi city and its surrounding greenery. Visitors often trek or climb the stone steps to reach the top. Sunsets here are particularly enchanting. Tagore Hill is Ranchi’s serene escape for writers, thinkers, and nature lovers."
  },
  {
    "title": "Rock Garden & Kanke Dam",
    "description": "Rock Garden is an artistic landscape crafted from natural rock formations, complete with sculptures, caves, and sitting spots. It is located beside Kanke Dam, which provides picturesque lake views. Families and couples enjoy strolling along the pathways and relaxing by the water. Evening lighting adds to its charm. Rock Garden and Kanke Dam are Ranchi’s favorite hangout destinations."
  },
  {
    "title": "Pahari Mandir",
    "description": "Pahari Mandir is a hilltop temple dedicated to Lord Shiva, situated at an elevation of about 2140 feet. Devotees climb over 400 steps to reach the shrine, gaining spiritual peace along with breathtaking city views. The Indian National Flag hoisted here adds patriotic pride. Festivals like Mahashivratri attract large crowds. Pahari Mandir is Ranchi’s sacred peak of devotion."
  },
  {
    "title": "Dassam Falls",
    "description": "Dassam Falls is a spectacular waterfall located on the Kanchi River, plunging from a height of around 144 feet. The gushing waters create misty waves and thundering sounds that thrill visitors. Surrounded by rugged terrain and forests, it is popular for picnics and photography. The area remains especially lively during monsoon. Dassam Falls is Ranchi’s roaring natural wonder."
  },
  {
    "title": "Patratu Valley",
    "description": "Patratu Valley is a breathtaking hill route lined with curving roads, lush forests, and captivating misty views. The journey itself is a favorite for bikers and travellers. At the base lies Patratu Dam, which adds tranquility with its sparkling waters. The scenery resembles international hill stations. Patratu Valley is Ranchi’s picturesque drive to paradise."
  },
  {
    "title": "Birsa Zoological Park",
    "description": "Birsa Zoological Park, also known as Ranchi Zoo, houses a variety of animals such as tigers, elephants, leopards, and deer in natural habitats. Safari rides and guided nature walks enhance the visitor experience. The lush greenery and educational displays make it ideal for families. Conservation efforts are well-highlighted. Birsa Zoo is Ranchi’s wildlife learning hub."
  },
  {
    "title": "Hundru Falls",
    "description": "Hundru Falls features the Subarnarekha River cascading from a height of about 320 feet, forming natural pools below. The rocky surroundings and splashing waters make it perfect for adventure enthusiasts and photographers. Trekking trails lead to scenic viewpoints. During monsoon, the waterfall becomes a massive curtain of white. Hundru Falls is Ranchi’s dramatic monsoon marvel."
  },
  {
    "title": "Sun Temple",
    "description": "The Sun Temple near Ranchi is shaped like a massive chariot with 18 wheels and seven horses, representing the Sun God’s celestial ride. Built with red sandstone, it reflects beautifully in the nearby pond. Tourists visit for both sightseeing and devotional rituals. Sunrise visits are particularly magical. Sun Temple is Ranchi’s radiant architectural icon."
  },
  {
    "title": "Jagannath Temple",
    "description": "Jagannath Temple in Ranchi resembles the Puri Jagannath Temple and sits atop a small hill. Built in 1691, it offers breathtaking views of the surrounding valleys. The annual Rath Yatra draws huge crowds of devotees. The peaceful environment makes it ideal for meditation. Jagannath Temple is Ranchi’s heritage of Odia devotion."
  },
  {
    "title": "Nakshatra Van",
    "description": "Nakshatra Van is a unique astrology-themed botanical garden where trees are planted according to the 27 Hindu constellations (Nakshatras). Visitors explore circular pathways lined with medicinal and sacred trees. A musical fountain and pond enhance the ambiance. It is ideal for evening walks and peaceful relaxation. Nakshatra Van is Ranchi’s celestial garden of tranquility."
  }
],


"services": [
  {
    "name": "Taxi Booking in Ranchi",
    "description": "Easily book your taxi in Ranchi with our efficient Taxi Booking service, designed to offer quick and hassle-free cab reservations. Whether you need a ride for daily commute, airport transfers, or special occasions, our platform ensures instant confirmation, competitive pricing, and a wide selection of vehicles to choose from. Enjoy reliable, safe, and comfortable travel with experienced drivers who know Ranchi’s routes well."
  },
  {
    "name": "Book Cab Ranchi",
    "description": "Book Cab Ranchi provides a seamless experience for travelers looking for prompt and dependable cab services. With options ranging from affordable sedans to spacious SUVs, this service is ideal for local rides, business trips, and airport transfers. Our cabs are maintained for safety and cleanliness, and drivers are trained for professional service, ensuring your ride is comfortable and timely."
  },
  {
    "name": "Online Taxi Service Ranchi",
    "description": "Our Online Taxi Service in Ranchi lets you schedule rides at your convenience through an easy-to-use digital platform. Enjoy features like secure payment, real-time tracking, and instant booking confirmations. Perfect for tech-savvy users and busy professionals, this service combines technology with reliable transportation to meet your every travel need."
  },
  {
    "name": "Best Taxi Ranchi",
    "description": "Experience the Best Taxi service in Ranchi, known for punctuality, professionalism, and customer satisfaction. Our fleet includes a variety of well-maintained vehicles driven by courteous chauffeurs, ensuring your journey is safe and comfortable. Ideal for business travelers, tourists, and locals alike, we strive to make every ride pleasant and reliable."
  },
  {
    "name": "Affordable Cab Booking Ranchi",
    "description": "Looking for budget-friendly yet quality cab options? Our Affordable Cab Booking service in Ranchi offers competitive rates without compromising on comfort or safety. Perfect for daily commuters and occasional travelers, this service balances cost-effectiveness with dependable rides, making transportation accessible for all."
  },
  {
    "name": "Local Taxi Ranchi",
    "description": "Local Taxi Ranchi specializes in short-distance rides within the city and nearby areas. Available 24/7, this service caters to residents and visitors who need quick, reliable transport for errands, meetings, or casual outings. Our knowledgeable drivers ensure you reach your destination efficiently and safely."
  },
  {
    "name": "24x7 Taxi Service Ranchi",
    "description": "Our 24x7 Taxi Service in Ranchi is always ready to serve you, regardless of the hour. Whether it’s an early morning airport drop or a late-night return from work, count on us for reliable, round-the-clock transportation. Safety, punctuality, and convenience are at the core of this service."
  },
  {
    "name": "Ranchi Sedan Taxi",
    "description": "Ride in style and comfort with our Ranchi Sedan Taxi service, offering spacious and well-maintained sedans for personal and business travel. Ideal for airport transfers, city rides, and longer trips, these sedans provide a smooth and enjoyable travel experience driven by professional chauffeurs."
  },
  {
    "name": "SUV Taxi Ranchi",
    "description": "Our SUV Taxi service in Ranchi is perfect for group travel, family outings, or those needing extra luggage space. Featuring premium SUVs equipped with modern amenities, this service ensures a comfortable, safe, and spacious ride with professional drivers familiar with Ranchi’s routes and traffic."
  },
  {
    "name": "Ranchi Taxi for Outstation",
    "description": "Planning a trip outside Ranchi? Our Ranchi Taxi for Outstation service offers reliable and affordable transportation to nearby cities and tourist destinations. Choose from a variety of vehicles for one-way or round-trip journeys, with experienced drivers ensuring a safe and enjoyable ride throughout."
  },
  {
    "name": "Airport Taxi Ranchi",
    "description": "Get timely and comfortable Airport Taxi service in Ranchi for your arrivals and departures. Our drivers monitor flight schedules to provide prompt pickups and drop-offs, making your travel hassle-free. Whether it’s business or leisure, start and end your journey with peace of mind."
  },
  {
    "name": "City Cab Booking Ranchi",
    "description": "Our City Cab Booking in Ranchi offers convenient transportation for all your urban travel needs. From office commutes and shopping trips to sightseeing tours, enjoy easy booking, quick pickups, and comfortable rides tailored to the city’s fast-paced environment."
  },
  {
    "name": "Taxi Near Me Ranchi",
    "description": "Find the nearest available taxi in Ranchi with our Taxi Near Me service, ensuring minimal wait times and swift pickups. This service is perfect for last-minute rides, emergency trips, or spontaneous travel plans, connecting you instantly with nearby drivers."
  },
  {
    "name": "Ranchi Travel Taxi",
    "description": "Explore Ranchi and surrounding areas with our Ranchi Travel Taxi service, offering guided and flexible travel options for tourists and locals. Whether you’re visiting landmarks, attending events, or on a leisure trip, our friendly drivers provide knowledgeable, safe, and comfortable rides."
  },
  {
    "name": "Trusted Taxi Service Ranchi",
    "description": "Our Trusted Taxi Service in Ranchi is built on a reputation of reliability, professionalism, and customer care. With thorough vehicle maintenance, verified drivers, and responsive customer support, we prioritize your safety and satisfaction on every journey."
  }
],
"tableData": [
  ["Taxi Booking in Ranchi", "Book Cab Ranchi"],
  ["Online Taxi Service Ranchi", "Best Taxi Ranchi"],
  ["Affordable Cab Booking Ranchi", "Local Taxi Ranchi"],
  ["24x7 Taxi Service Ranchi", "Ranchi Sedan Taxi"],
  ["SUV Taxi Ranchi", "Ranchi Taxi for Outstation"],
  ["Airport Taxi Ranchi", "City Cab Booking Ranchi"],
  ["Taxi Near Me Ranchi", "Ranchi Travel Taxi"],
  ["Trusted Taxi Service Ranchi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Taxi Booking Service in Ranchi",
    "WhyChoosedescription": "Aaryan Travels offers dependable and convenient taxi booking services throughout Ranchi for all your travel needs."
  },
  {
    "WhyChooseheading": "Quick and Convenient Pickup Anywhere in Ranchi",
    "WhyChoosedescription": "Our drivers are always nearby to ensure prompt pickups and smooth rides across the city."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis designed for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Ranchi Roads",
    "WhyChoosedescription": "Our professional drivers know the city well to provide efficient and timely rides."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage preferences."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer taxi booking services in Ranchi?',
    answer: 'Yes, Aaryan Travels provides reliable and convenient taxi booking services across Ranchi for local and outstation travel.',
  },
  {
    question: 'How can I book a taxi in Ranchi with Aaryan Travels?',
    answer: 'You can book your taxi easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of taxis are available for booking in Ranchi?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Can I book a taxi for both local travel and outstation trips from Ranchi?',
    answer: 'Yes, Aaryan Travels provides taxi services for local rides as well as outstation trips from Ranchi to various destinations.',
  },
  {
    question: 'Are the drivers experienced and familiar with Ranchi routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with Ranchi and surrounding areas to ensure safe travel.',
  },
  {
    question: 'Is hourly taxi rental available in Ranchi?',
    answer: 'Yes, we offer hourly rental packages for flexible taxi hire options in Ranchi.',
  },
  {
    question: 'Are safety and hygiene protocols followed for taxi services in Ranchi?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to protect passengers.',
  },
  {
    question: 'Is taxi booking service in Ranchi available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 taxi booking and services throughout Ranchi.',
  },
  {
    question: 'What payment options are accepted for taxi bookings in Ranchi?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for smooth and secure transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations within Ranchi?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Ranchi as per your travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kumar',
    feedback: 'The taxi service by Aaryan Travels in Ranchi was prompt, comfortable, and hassle-free. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Singh',
    feedback: 'Smooth booking and excellent taxi service in Ranchi. Great experience with Aaryan Travels.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Booking in Ranchi",
  "image": "https://aaryantravels.com/assets/images/taxi-booking-ranchi.jpg", // replace with actual image URL
  "description": "Reliable and affordable taxi booking service in Ranchi by Aaryan Travels. Available 24x7 with options for sedan, SUV, local and outstation rides. Book your taxi online easily.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",  // example rating, update if needed
    "ratingCount": "2200", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/taxi-booking-ranchi"
  }
};




  return (
    <div>

<Helmet>
  <title>Taxi Booking in Ranchi | Reliable & Affordable Cab | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable taxi booking service in Ranchi by Aaryan Travels. Available 24x7 with options for sedan, SUV, local and outstation rides. Book your taxi online easily."
  />
  <meta
    name="keywords"
    content="Taxi Booking in Ranchi, Book Cab Ranchi, Online Taxi Service Ranchi, Best Taxi Ranchi, Affordable Cab Booking Ranchi, Local Taxi Ranchi, 24x7 Taxi Service Ranchi, Ranchi Sedan Taxi, SUV Taxi Ranchi, Ranchi Taxi for Outstation, Airport Taxi Ranchi, City Cab Booking Ranchi, Taxi Near Me Ranchi, Ranchi Travel Taxi, Trusted Taxi Service Ranchi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxibookinginracnchi;